import { useCallback, useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";

import { useGetGreetingsOptions } from "./useGetGreetingsOption";

interface UseGreetingSentenceProps {
    greetingIndex: number;
    dialogueIndex: number;
    sentenceIndex: number;
    onMarkChanged: () => void;
}

export const useGreetingSentence = ({
    greetingIndex,
    dialogueIndex,
    sentenceIndex,
    onMarkChanged,
}: UseGreetingSentenceProps) => {
    const { setValue, getValues, watch } = useFormContext();
    const [isAdvancedOpen, setIsAdvancedOpen] = useState(false);

    // 取得表情與動作選項
    const FACE_OPTIONS = useGetGreetingsOptions("FACE_OPTIONS") || [];
    const ACTION_OPTIONS = useGetGreetingsOptions("ACTION_OPTIONS") || [];

    // 字段名稱
    const audioFileFieldName = `audioFile_${greetingIndex}_${dialogueIndex}_${sentenceIndex}`;
    const audioUrlFieldName = `greetings.data.${greetingIndex}.dialogues.${dialogueIndex}.sentences.${sentenceIndex}.audio_url`;
    const timestampFieldName = `greetings.data.${greetingIndex}.dialogues.${dialogueIndex}.sentences.${sentenceIndex}.updated_time`;

    // 監聽字段值
    const existingAudioUrl = watch(audioUrlFieldName);
    const audioFile = watch(audioFileFieldName);

    const handleFieldChange = useCallback(() => {
        setValue(timestampFieldName, new Date().toISOString(), { shouldDirty: true });
        onMarkChanged();
    }, [setValue, timestampFieldName, onMarkChanged]);

    const handleAddNewline = useCallback(() => {
        const fieldName = `greetings.data.${greetingIndex}.dialogues.${dialogueIndex}.sentences.${sentenceIndex}.content`;
        const currentValue = getValues(fieldName) || "";
        setValue(fieldName, currentValue + "\\n", { shouldDirty: true });
        handleFieldChange();
    }, [greetingIndex, dialogueIndex, sentenceIndex, getValues, setValue, handleFieldChange]);

    const handleDeleteAudio = useCallback(() => {
        setValue(audioUrlFieldName, "", { shouldDirty: true, shouldValidate: true });
        handleFieldChange();
    }, [audioUrlFieldName, setValue, handleFieldChange]);

    // 監聽音檔上傳
    useEffect(() => {
        if (audioFile) {
            handleFieldChange();
        }
    }, [audioFile, handleFieldChange]);

    return {
        // 狀態
        isAdvancedOpen,
        setIsAdvancedOpen,
        FACE_OPTIONS,
        ACTION_OPTIONS,
        audioFileFieldName,
        audioUrlFieldName,
        timestampFieldName,
        existingAudioUrl,
        audioFile,
        // 事件處理
        handleFieldChange,
        handleAddNewline,
        handleDeleteAudio,
    };
};
